import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-search-box-table',
  templateUrl: './search-box-table.component.html',
  styleUrls: ['./search-box-table.component.scss']
})
export class SearchBoxTableComponent implements OnInit {

  /**
   * Subtitle for show the message.
   *
   * @type {string}
   * @memberof SearchBoxTableComponent
   */
  @Input()
  subtitle: string;
  constructor() { }

  ngOnInit() {
  }

}
